import React from 'react';
import { fmtDay, fmtQty, fmtVal } from './fmt';

const tip = (c, metric) => [
  `${c.days} days present (${c.days_worked} with scans${c.idle_days ? `, ${c.idle_days} without` : ''})`,
  `${c.hours_est ? '~' : ''}${c.hours} h · ${fmtQty(c.qty)} pcs`,
  c.high ? `Best day ${fmtVal(c.high.value, metric)} on ${fmtDay(c.high.date)}` : '',
  c.low_day ? `Lowest day ${fmtVal(c.low_day.value, metric)} on ${fmtDay(c.low_day.date)}` : '',
  c.high ? '(a day shared with another operation is scaled to its share of the day)' : '',
  c.judged ? '' : 'Too few days to judge',
].filter(Boolean).join('\n');

/** A staff's month in one operation: the ranking value + best (H) / lowest (L) day. */
export const MonthCell = ({ cell, metric, testId }) => {
  if (!cell) return <td className="px-2 py-2 text-center text-gray-300 border-l border-gray-100" data-testid={testId}>—</td>;
  const cls = cell.low ? 'bg-rose-100 text-rose-900' : cell.judged ? 'text-gray-900' : 'text-gray-400';
  return (
    <td className={`px-2 py-1.5 text-center border-l border-gray-100 whitespace-nowrap ${cls}`} title={tip(cell, metric)} data-testid={testId} data-low={cell.low ? '1' : '0'}>
      <div className="font-semibold tabular-nums text-sm">{fmtVal(cell.value, metric)}</div>
      {(cell.high || cell.low_day) && (
        <div className="text-[10px] tabular-nums opacity-75">
          H {fmtVal(cell.high?.value, metric)} · L {fmtVal(cell.low_day?.value, metric)}
        </div>
      )}
    </td>
  );
};

export default MonthCell;
